<template>
    <div class="invite_enroll" ref="imageDom">
        <div class="yfkh"></div>
        <span class="share" @click="clickGeneratePicture" v-show="imgShow">
            <span class="share_img"></span>
            <span class="share_text">分享</span>
        </span>
        <div class="centre_box" ref="centre_box">
            <div class="frame">
                <div id="qrcode"></div>
            </div>
            <div class="details_text" ref="details_text">
                <p>扫 码 下 单 ， 快 速 开 单</p>
                <p>信 息 及 时 ， 自 助 查 询</p>
                <p>货 物 路 径 ， 一 目 了 然</p>
                <p>自 动 存 储 ， 对 账 方 便</p>
            </div>
            <div class="platform_img" ref="platform_img"></div>
        </div>

        <div class="invite_number" v-show="imgShow">
            <p class="people">当前有效邀请人数 ：{{inviteCount}}</p>
            <p class="people">今天有效邀请人数 ：{{inviteCountSpecifiedTime}}</p>
            <div style="display: flex;">
                <van-button class="details_btn" round plain @click="handleDetails">{{btnType==1?'查看详情':'返回'}}
                </van-button>
                <van-button class="details_btn" round plain @click="handleOrderDetails">{{'订单明细'}}
                </van-button>
            </div>
        </div>
        <div class="details" v-show="detailShow && imgShow">
            <van-pull-refresh
                    v-model="loading"
                    style="padding-bottom: 1.7rem;box-sizing: border-box;height: 100%"
                    @refresh="onRefresh">
                <van-list
                        :loading="loading"
                        :finished="finished"
                        @load="onLoad">
                    <div class="no-list" v-if="data.length === 0">暂无数据</div>
                    <p v-else v-for="(item,index) in data" :key="index"
                       style="color: #fff;line-height: .58rem;text-align: center">
                        <span>{{item.inviteeMobile}}</span>
                        <span style="margin-left: .3rem;overflow: hidden;white-space:nowrap;">{{item.createDate}}</span>
                    </p>
                </van-list>
            </van-pull-refresh>
        </div>
        <van-image-preview v-model="show" :images="images" @change="onChange">
            <template v-slot:index>{{ index }}/{{ index }}</template>
        </van-image-preview>
    </div>
</template>

<script>
    import QRCode from "qrcodejs2"
    import html2canvas from 'html2canvas'
    import {Toast} from "vant"

    const wx = require("weixin-js-sdk")

    export default {
        name: "inviteEnroll",
        components: {
            QRCode,
        },
        data() {
            return {
                imgUrl: null,
                show: false,
                index: 0,
                images: [],
                imgShow: true,
                loading: false,
                data: [],
                hasNextPage: true,
                // 加载是否已完成
                finished: false,
                detailShow: false,
                pageNum: 1,
                btnType: 1,                
                inviteCode: "",
                inviteCount: 0,
                inviteCountSpecifiedTime: 0,
            }
        },
        mounted() {
            this.getData(true)
            let div = document.getElementsByClassName('invite_enroll')[0]
            let height = div.clientHeight
            if (height < 600) {
                this.$refs.centre_box.style.top = "43%"
                this.$refs.details_text.style.marginTop = ".3rem"
                this.$refs.platform_img.style.marginTop = ".3rem"
            }
        },
        watch: {
            $route(to, form) {
                if (to.name === 'inviteEnroll') {
                    this.getData(true)
                    // if (this.inviteCode) this.handleShare()
                }
            }
        },
        created() {
            this.handleShare()
        },
        methods: {
            getData(empty) {
                let params = {
                    page: {
                        pageNum: this.pageNum,
                        pageSize: 10,
                    },
                    params: {
                        type: this.$wechatMark,
                        logisticsCompanyId: this.$logisticsCompanyId
                    }
                }
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '加载中...',
                    mask: true
                })
                this.$axios.post('/invite/extend/statistics', params).then(res => {
                    let data = res.data.data
                    this.inviteCount = data.params.total  //当前有效
                    if (!this.inviteCode) {
                        this.inviteCode = data.params.inviteCode  //邀请码
                        // this.handleShare()
                    }
                    this.inviteCountSpecifiedTime = data.params.todayCount //今天有效
                    if (empty) {
                        this.qrcode()
                        this.data = data.list

                    } else {
                        this.data = this.data.concat(data.list);
                        this.pageNum++
                    }
                    this.loading = false
                    this.refresh = false
                    this.finished = !data.hasNextPage;
                    this.hasNextPage = data.hasNextPage;
                }).finally(() => this.$toast.clear())
            },
            handleDetails() {
                this.detailShow = !this.detailShow
                this.btnType = this.btnType == 1 ? 2 : 1
            },
            handleOrderDetails() {
                this.$router.push("/invite/extend/details")                
            },
            // 加载列表
            onLoad() {
                this.loading = true;
                this.getData(false);
            },
            // 下拉刷新
            onRefresh() {
                this.pageNum = 1;
                this.loading = true;
                this.getData(true);
                this.refresh = true;
            },
            /**
             * 生成二维码
             * */
            qrcode() {
                document.getElementById("qrcode").innerHTML = "";
                let qrcode = new QRCode('qrcode', {
                    text: 'https://kl.cg1717.com/user/register?inviteCode=' + this.inviteCode + '&inviteSource=WECHAT',   // 二维码内容
                })
            },
            onChange(index) {
                this.index = index;
            },
            /**
             * 将页面指定节点内容转为图片
             * 1.拿到想要转换为图片的内容节点DOM；
             * 2.转换，拿到转换后的canvas
             * 3.转换为图片
             */
            clickGeneratePicture() { //生成图片
                // this.generating = true;
                this.imgShow = false
                document.querySelector('.app-header').style.display = "none"
                this.$nextTick(() => {
                    html2canvas(this.$refs.imageDom).then(canvas => {
                        // this.generating = false;
                        this.title = '邀请您注册';
                        // 转成图片，生成图片地址
                        const imgUrl = canvas.toDataURL("image/png"); //可将 canvas 转为 base64 格式
                        const ctx = canvas.getContext('2d');
                        const image = new Image();
                        image.onload = () => {
                            const imgWidth = document.body.offsetWidth * 2;
                            const imgHeight = imgWidth / image.width * image.height;
                            const titleHeight = document.querySelector('.app-header').offsetHeight * 2; // title 高度
                            let titleFontSize = getComputedStyle(document.querySelector('.app-header')).fontSize; // title 文字大小
                            titleFontSize = titleFontSize.slice(0, titleFontSize.indexOf('px')) * 2;
                            canvas.width = imgWidth;
                            canvas.height = imgHeight + titleHeight; // 设置canvas大小, canvas预留title位置
                            ctx.fillStyle = '#042D6F';
                            ctx.fillRect(0, 0, imgWidth, imgHeight); // 填充canvas背景色
                            ctx.font = `${titleFontSize}px Helvetica Neue, Helvetica, Microsoft YaHei`;
                            ctx.fillStyle = '#fff';
                            const fontWidth = ctx.measureText('邀请您注册').width;
                            ctx.fillText('邀请您注册', imgWidth / 2 - fontWidth / 2, titleHeight / 2 + (titleFontSize / 2));
                            ctx.drawImage(image, 0, titleHeight, imgWidth, imgHeight);
                            this.imgUrl = canvas.toDataURL('image/png');
                            let isWxLogin = window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
                            if (isWxLogin) {
                                Toast({
                                    message: '长按图片保存',
                                    duration: 3000
                                });
                                this.show = true;
                                // touchstart
                                this.images[0] = this.imgUrl;
                            } else {
                                let eleLink = document.createElement("a");
                                eleLink.href = this.imgUrl; // 转换后的图片地址
                                eleLink.download = "【" + this.inviteCode + "】邀请码";
                                document.body.appendChild(eleLink);
                                // 触发点击
                                eleLink.click();
                                // 然后移除
                                document.body.removeChild(eleLink);
                            }
                            document.querySelector('.app-header').style.display = "block"
                            this.imgShow = true
                        }
                        image.src = imgUrl;
                    });
                });
                // this.title = '运单信息';
            },
            /**
             * 微信分享
             * */
            handleShare() {
                let url = this.$isIosOrAndroid() === "android" ? window.location.href : window.initUrl;
                let params = {
                    params: {
                        logisticsCompanyId: this.$logisticsCompanyId,
                        url
                    }
                }
                this.$axios.post("pay/config", params).then(res => {
                    let data = res.data.data
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: data.appId, // 必填，公众号的唯一标识
                        timestamp: data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: data.nonceStr, // 必填，生成签名的随机串
                        signature: data.signature,// 必填，签名
                        jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
                    });
                    wx.error(function (res) {
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    });
                })

                wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
                    this.friendCircle()
                    this.friend()
                });
            },

            /**
             * 分享朋友
             * */
            friendCircle() {
                wx.updateAppMessageShareData({
                    title: '邀请注册', // 分享标题
                    desc: '邀请您注册', // 分享描述
                    link: 'https://kl.cg1717.com/user/register?inviteCode=' + this.inviteCode, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: 'https://kl.cg1717.com/background1.png', // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        alert('分享失败');
                    }
                })
            }
            ,
            /**
             * 分享朋友圈
             * */
            friend() {
                wx.updateTimelineShareData({
                    title: '邀请注册', // 分享标题
                    desc: '邀请您注册', // 分享描述
                    link: 'https://kl.cg1717.com/user/register?inviteCode=' + this.inviteCode, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: 'https://kl.cg1717.com/background1.png', // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        alert('分享微信好友失败');
                    }
                })
            }
            ,

        }
    }
</script>

<style lang="scss">
    .invite_enroll {
        width: 100%;
        height: 100%;
        /*background: url("../../assets/background@2x.png");*/
        background: url("../../assets/background1.png");
        background-size: 100% 100%;
        position: relative;
        font-size: .4rem;


        .yfkh {
            position: absolute;
            left: 1rem;
            top: 0.14rem;
            width: 2.73rem;
            height: 1.43rem;
            background: url("../../assets/yfkh.png") center / 100% no-repeat;
        }

        .details_btn {
            letter-spacing: 0.2rem;
            background-color: transparent;
            color: #bb9763;
            border-color: #bb9763;
            height: 0.8rem;
            width: 5.5rem;
            margin-top: .3rem;
            margin-right: 0.4rem;
        }

        .people {
            width: 100%;
            display: inline-block;
            color: #fff;
            line-height: .6rem;
            text-align: center;
        }

        .details {
            width: 7.35rem;
            height: 9rem;
            background: rgba(2, 1, 1, 0.5);
            box-sizing: border-box;
            padding: .3rem;
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            margin: auto;
            overflow: auto;
            transform: translateY(-50%);
            -webkit-overflow-scrolling: touch;
        }

        .invite_number {
            width: 7.16rem;
            height: 2.5rem;
            position: absolute;
            bottom: 0rem;
            left: 50%;
            transform: translateX(-50%);
            bottom: 1rem;
        }

        .share {
            display: inline-block;
            position: absolute;
            right: .2rem;
            top: .5rem;
            width: auto;
            height: .56rem;

            .share_img {
                display: inline-block;
                width: 0.56rem;
                height: 0.56rem;
                background: url("../../assets/share@2x.png") center / 100% no-repeat;
                vertical-align: top;
            }

            .share_text {
                line-height: .56rem;
                vertical-align: top;
                color: #22478f;
                margin-left: .1rem;
            }


        }
    }

    .frame {
        /*position: absolute;*/
        width: 3.6rem;
        height: 3.6rem;
        left: 0;
        right: 0;
        margin: auto;
        top: 2rem;
        background: url("../../assets/frame.png") center / 100% no-repeat;
    }

    .details_text {
        color: #fff;
        text-align: center;
        font-size: .48rem;
        margin-top: .5rem;
    }

    .centre_box {
        position: absolute;
        width: 100%;
        height: 8rem;
        top: 45%;
        transform: translateY(-50%);
    }

    .platform_img {
        width: 8.85rem;
        height: 0.97rem;
        margin: .5rem auto;
        background: url("../../assets/platform_img@2x.png") center / 100% no-repeat;
    }

    #qrcode {
        width: 3rem;
        height: 3rem;
        margin: auto;
        position: relative;
        top: .3rem;

        img, canvas {
            width: 3rem !important;
        }
    }
</style>